import React, { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "components/Layout";
import api from "utils/api";
import "styles/auth.css";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setFeedback(null);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, brand: "dr-hoffmann" });
      setFeedback({
        kind: "success",
        message:
          data?.message ||
          "Falls ein Konto mit dieser E-Mail existiert, wurde ein Link zum Zurücksetzen gesendet.",
      });
    } catch (err) {
      setFeedback({
        kind: "error",
        message: err?.response?.data?.message || "Anfrage fehlgeschlagen.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <section className="auth-page">
        <div className="auth-card">
          <div className="auth-kicker">Passwort zurücksetzen</div>
          <h1>
            Passwort <em>vergessen?</em>
          </h1>
          <p className="auth-lead">
            Gib deine E-Mail-Adresse ein. Wir senden dir einen Link, mit dem du dein
            Passwort innerhalb von 30 Minuten zurücksetzen kannst.
          </p>

          {feedback && (
            <div className={`auth-alert is-${feedback.kind}`}>{feedback.message}</div>
          )}

          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <div>
              <label htmlFor="forgot-email">E-Mail</label>
              <input
                id="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="auth-actions">
              <button type="submit" className="auth-submit" disabled={submitting}>
                {submitting ? "Anfrage senden..." : "Link senden"}
              </button>
            </div>
          </form>

          <div className="auth-links">
            <Link to="/einloggen">Zurück zum Login</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ForgotPasswordPage;
